import React from 'react';

import { SimpleObject } from '@clearverify/types';

import { Modal } from 'src/components/common';
import { VerifierVerifyAutomaticByCVStaffModalForm } from 'src/components/verifier';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export interface VerifierVerifyAutomaticByCVStaffModalArgs extends SimpleObject {
  verifierId: string;
}

export const VerifierVerifyAutomaticByCVStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<VerifierVerifyAutomaticByCVStaffModalArgs>(
      ModalId.VerifierVerifyAutomaticByCVStaffModal,
    );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Verify Automatically"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      headerPadding="16px 32px 0 32px"
      maxWidth={800}
    >
      <VerifierVerifyAutomaticByCVStaffModalForm
        verifierId={args?.verifierId}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
